 export enum EtatTransfertEnum {
Default = 0,
EnAttente = 1,
Envoye = 2,
Traite = 3,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/EtatTransfertEnum.ts